import { RouterModule } from '@angular/router';

import { CursoComponent } from './curso/curso.component';
import { DadosPessoaisComponent } from './dados-pessoais/dados-pessoais.component';
import { ParcelamentoComponent } from './parcelamento/parcelamento.component';
import { PagamentoComponent } from './pagamento/pagamento.component';
import { FinalizacaoComponent } from './finalizacao/finalizacao.component';
import { InscricaoComponent } from './inscricao.component';

export const INSCRICAO_ROUTER = [
  {
    path: 'inscricao',
    component: InscricaoComponent,
    name: 'inscricao',
    children: [
      { path: 'curso', component: CursoComponent },
      { path: 'dados-pessoais', component: DadosPessoaisComponent },
      { path: 'parcelamento', component: ParcelamentoComponent },
      { path: 'pagamento', component: PagamentoComponent },
      { path: 'finalizacao', component: FinalizacaoComponent },
    ],
  },
];

export const InscricaoRouter = RouterModule.forChild(INSCRICAO_ROUTER);
